<template>
    <SettingsPaygroups :client="client" @updated="onSetupComplete"/>
</template>

 <script>
    import SettingsPaygroups from '@/pages/client/Settings/Paygroups'

    export default {
        props: ['client', 'setupStatus'],
        components: {SettingsPaygroups},
        data() {
            return {}
        },
        methods: {
            onSetupComplete() {
                this.$store.dispatch('START_LOADING')
                this.$api.post(`/clients/${this.client.id}/setup-status`, {step: 'pay_groups'}).then(resp => {
                    this.$store.dispatch('STOP_LOADING')
                    this.$emit('refreshClient')
                }).catch((errors) => {
                    this.$store.dispatch('STOP_LOADING')
                    this.$bus.showError(errors.__all__)
                })
            },
        },
    }
    </script>
